import { Referral as Api } from '@synapex/shared2/gateway-rest-api';

export const referrals = (reply: Api.getMany.Reply) => reply;
export type Referral = ReturnType<typeof referrals>[number];

export const referralsCount = (reply: Api.getMany.Reply) => reply.length;
